import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Stack, Text, Card } from '@hub-la/design-system';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import PixIcon from '@mui/icons-material/Pix';
import { useFormikContext } from 'formik';
import { BankAccountForm } from './bank-account-form.js';
import { PixKeyForm } from './pix-key-form.js';

const WithdrawalForm = () => {
  const {
    values,
    setFieldValue
  } = useFormikContext();
  return jsxs(Fragment, {
    children: [jsxs(Stack, Object.assign({
      direction: "column",
      spacing: 4
    }, {
      children: [jsx(Stack, Object.assign({
        direction: "row",
        spacing: 1
      }, {
        children: jsx(Text, {
          children: "M\u00E9todo de saque"
        })
      })), jsxs(Stack, Object.assign({
        direction: ['column', 'row'],
        gap: [3, 6]
      }, {
        children: [jsx(Card, Object.assign({
          variant: "outlined",
          hasHover: true,
          selected: values.isPixKey,
          onClick: () => setFieldValue('isPixKey', true)
        }, {
          children: jsxs(Stack, Object.assign({
            direction: "row",
            alignItems: "center",
            spacing: 4
          }, {
            children: [jsx(PixIcon, {}), jsx(Text, {
              children: "Chave Pix"
            })]
          }))
        })), jsx(Card, Object.assign({
          variant: "outlined",
          hasHover: true,
          selected: !values.isPixKey,
          onClick: () => setFieldValue('isPixKey', false)
        }, {
          children: jsxs(Stack, Object.assign({
            direction: "row",
            alignItems: "center",
            spacing: 4
          }, {
            children: [jsx(AccountBalanceOutlinedIcon, {}), jsx(Text, {
              children: "Dados banc\u00E1rios"
            })]
          }))
        }))]
      }))]
    })), values.isPixKey ? jsx(PixKeyForm, {}) : jsx(BankAccountForm, {})]
  });
};

export { WithdrawalForm };
